// src/app/services/expenseService.ts
import axiosInstance from '@/app/api/axiosInstance';
import { ExpenseRecordCreate } from '@/app/types/expense'; // Create this type based on backend schema
import { VoucherResponse } from '@/app/types/voucher';

const API_URL = '/expenses'; // Base URL for expenses

/**
 * Records an expense.
 * @param expenseData - The expense data matching the ExpenseRecordCreate schema.
 * @returns Promise<VoucherResponse> - The created voucher (PINV, PMT, or JV).
 */
export const recordExpense = async (expenseData: ExpenseRecordCreate): Promise<VoucherResponse> => {
  try {
    console.log("Sending expense data:", JSON.stringify(expenseData, null, 2)); // Log formatted payload
    const response = await axiosInstance.post<VoucherResponse>(`${API_URL}/record`, expenseData);
    return response.data;
  } catch (error) {
    console.error('Error recording expense:', error);
    // Re-throw the error to be caught by react-query or the calling component
    throw error;
  }
};

// Add functions for listing, getting, updating, deleting expenses if needed
// based on whether the backend provides specific endpoints or if it's handled
// via the generic /vouchers endpoint with filters.

// Example for listing expenses (assuming they are specific voucher types):
// import { listVouchers } from './voucherService'; // Import generic voucher listing
// export const listExpenses = async (params: any) => {
//   // Modify params to filter by relevant voucher type codes/ids
//   const expenseVoucherTypeCodes = ['PINV', 'PMT', 'JV']; // Example codes
//   // You might need to fetch voucher types first to get IDs if filtering by ID
//   const filters = params.filters ? JSON.parse(params.filters) : [];
//   filters.push({ field: 'voucher_type.code', op: 'in', value: expenseVoucherTypeCodes });
//   params.filters = JSON.stringify(filters);
//   return listVouchers(params);
// }; 